import React, { Component } from 'react';
import { BrowserRouter as Router, Switch, Route, Redirect } from 'react-router-dom';
import { Button, Panel, FormControl, FormGroup, Radio, Checkbox } from 'react-bootstrap';
import DatePicker from 'react-bootstrap-date-picker';
import InstructorNotesPage from './components/InstructorNotesPage';
import AboutPage from './components/AboutPage';
import HomePage from './components/HomePage';
import CheckFiguresPage from './components/CheckFiguresPage';
import LegalPage from './components/LegalPage';
import Navigation from './components/Navigation';
import Footer from './components/Footer';
import { saveAs } from 'file-saver';
import R from 'ramda';
import styled from 'styled-components';
require('bootstrap/dist/css/bootstrap.css');
require('bootstrap/dist/css/bootstrap-theme.css');

const LmsInputKey = 'lmsChoice';
const TopicKey = 'topics';
const PresentationMethodKey = 'presentationMethod';
const SubmissionMethodKey = 'submissionMethod';

const styles = {
  block: {
    maxWidth: 700,
    marginLeft: "auto",
    marginRight: "auto",
  },

  form: {
    maxWidth: 700,
    marginLeft: "auto",
    marginRight: "auto",
    display: 'flex',
    flexDirection: 'column',
  },
}

const FormLabel = styled.div`
  width: 100%;
  max-width: 250px;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  text-align: right;
  margin: 10px 2em;
`;

const FormRow = styled.div`
  display: flex;
  flex-direction: row;
  padding: 10px;
`;

const FormField = styled.div`
  margin: 10px 0px;
  max-width: 350px;
`;

const convertDocument = (doc, downloadOptions) => {
  console.log("Doc is: " + doc);
  console.log(doc);
  const extension = downloadOptions.fileExtension;
  fetch('/api/convert?ext='+extension, {method: 'POST', body: JSON.stringify(doc), mode: 'cors'})
    .then(function(response) {
      // TODO: check that response was okay
      const body = response.blob();
      return body;
    })
    .then(function(blob) {
      saveAs(blob, downloadOptions.fileName + '.' + extension);
    })
}

class App extends Component {
  constructor() {
    super();
    this.state = {
      form: {
        groupSize: 3,
        studentsSelectOwnGroups: false,
        numCompanies: 2,
        lmsChoice: 'blackboard',
        lmsOther: '', // just used for text input if they don't pick a standard one
        notificationMethod: 'email',
        email: '',
        presentationMethod: 'in-class',
        presentationLength: '5', // TODO: convert to int
        submissionMethod: 'email',
        plagiarismChecker: true,
        instructions10k: true,
        includePresentationRubric: true,
        includePaperRubric: true,
        topics: [],
        companyChoiceDueDate: new Date().toISOString(),
        presentationDueDate: new Date().toISOString(),
        paperDueDate: new Date().toISOString(),
        paperLength: '10', // TODO: add a form field for this, convert to int
        instructorName: '',
      },
      downloadOptions: {
        fileExtension: 'docx',
        fileName: 'case-assignment',
      }
    };

    this.handleFormSelect = this.handleFormSelect.bind(this);
    this.handleFormMultiselect = this.handleFormMultiselect.bind(this);
    this.handleFormCheck = this.handleFormCheck.bind(this);
    this.handleFormText = this.handleFormText.bind(this);
    this.handleFormDate = this.handleFormDate.bind(this);
  }

  render() {
    return (
      <Router>
        <div>
          <Navigation />
          <Switch>
            <Route exact path="/" component={HomePage} />
            <Route exact path="/casetemplate" render={() => (
                <InputForm
                  values={this.state.form}
                  selectHandler={this.handleFormSelect}
                  multiselectHandler={this.handleFormMultiselect}
                  checkHandler={this.handleFormCheck}
                  textHandler={this.handleFormText}
                  dateHandler={this.handleFormDate}
                  downloadOptions={this.state.downloadOptions}
                />
              )}
            />
            <Route exact path="/about" component={AboutPage} />
            <Route exact path="/teachingnotes" component={InstructorNotesPage} />
            <Route exact path="/checkfigures" component={CheckFiguresPage} />
            <Route exact path="/legal" component={LegalPage} />
            <Redirect from="*" to="/" />
          </Switch>
          <Footer />
        </div>
      </Router>
    );
  }

  handleFormSelect(fieldName, converter= (x)=>(x)) {
    return (event => {
      event.persist();
      this.setState((prevState, props) =>
          ({form: {...prevState.form, [fieldName]: converter(event.target.value)}}));
    });
  }

  handleFormMultiselect(fieldName) {
    return (event => {
      event.persist();
      this.setState((prevState, props) => {
        const updatedValue = event.target.value;
        const value = R.cond([
          [R.contains(updatedValue), R.without(updatedValue)],
          [R.T, R.append(updatedValue)]
        ])(prevState.form[fieldName]);
        return {form: {...prevState.form, [fieldName]: value}};
      });
    });
  }

  handleFormCheck(fieldName) {
    return (event => {
      event.persist();
      this.setState((prevState, props) =>
          ({form: {...prevState.form, [fieldName]: event.target.checked}}));
    });
  }

  handleFormText(fieldName) {
    return ((event) => {
      this.setState((prevState, props) =>
          ({form: {...prevState.form, [fieldName]: event.target.value}}));
    });
  }

  handleFormDate(fieldName) {
    return ((date, formattedDate) => {
      this.setState((prevState, props) =>
          ({form: {...prevState.form, [fieldName]: date}}));
    });
  }

}

const stripNonNumbers = evt => ({
  target: {
    value: evt.target.value.replace(/\D/g,'')
  }
})

const PanelHeader = styled.h3`
  text-align: center;
`;

class InputForm extends Component {
  render() {
    const defaultProps = {
      values: this.props.values,
      selectHandler: this.props.selectHandler,
      multiselectHandler: this.props.multiselectHandler,
      textHandler: this.props.textHandler,
      checkHandler: this.props.checkHandler,
      dateHandler: this.props.dateHandler,
      noPresentation: this.props.values[PresentationMethodKey] === 'none',
      noPaper: this.props.values[SubmissionMethodKey] === 'none',
    };
    return (
      <div style={styles.form} >
        <Panel>
          <p><i>Once you have completed filling out the fields below with your preferences, you will be able to download a multi-page Word document containing the case assignment. You are free to use the downloaded case assignment as is, or edit it further as you wish.</i></p>
          <p><b>Please note that this Accounting Case Template will work on a computer, not a mobile device.</b></p>
        </Panel>

        <Panel>
          <PanelHeader>Basic Information</PanelHeader>

          <GroupSizePicker {...defaultProps} />
          <NumberOfCompaniesPicker {...defaultProps} />
          <SelectionTypePicker {...defaultProps} />
          <ProfEmailInput {...defaultProps} />
          <ProfNameInput {...defaultProps} />
          <LmsInput {...defaultProps} />
          { this.props.values[LmsInputKey] !== 'other' ||
            <LmsOtherInput {...defaultProps} />
          }
          <NotificationMethodPicker {...defaultProps} />
          <CompanyChoiceDueDatePicker {...defaultProps} />
          <InstructionsFor10K {...defaultProps} />
        </Panel>

        <Panel>
          <PanelHeader>Topics</PanelHeader>

          <TopicPicker {...defaultProps} />
        </Panel>

        <Panel>
          <PanelHeader>Oral presentation details</PanelHeader>

          <PresentationMethodPicker {...defaultProps} />
          <PresentationDueDatePicker {...defaultProps} disabled={defaultProps.noPresentation} />
          <PresentationLengthInput {...defaultProps} disabled={defaultProps.noPresentation} />
          <RubricForPresentation {...defaultProps} disabled={defaultProps.noPresentation} />
        </Panel>

        <Panel>
          <PanelHeader>Written paper details</PanelHeader>

          <SubmissionMethodPicker {...defaultProps} />
          <PaperDueDatePicker {...defaultProps} disabled={defaultProps.noPaper} />
          <RubricForPaper {...defaultProps} disabled={defaultProps.noPaper} />
          <PlagiarismPicker {...defaultProps } disabled={defaultProps.noPaper} />
        </Panel>

        <div className="text-center">
          <Button
            bsStyle="primary"
            bsSize="large"
            onClick={() => convertDocument(this.props.values, this.props.downloadOptions)}
            style={{ marginBottom: "4em" }}
          >
            Download
          </Button>
        </div>
      </div>
    );
  }
}

// Each item should have .value and .description
const FormSelector = (key, labelText, items, multiple, converter=(x)=>(x)) => (
  ((props) => {
    const value = props.values[key];

    const radioItems = items.map((item, idx) =>
      <Radio
        key={key + item.value}
        name={`radio-${key}`}
        value={item.value}
        checked={item.value === value}
        onChange={() => {}}
      >{item.description}</Radio>
    );

    return (
      <FormRow>
        <FormLabel>{labelText}</FormLabel>
        <FormGroup
            value={value}
            onChange={props.selectHandler(key, converter)}
            id={"select-"+key}
        >
         {radioItems}
        </FormGroup>
      </FormRow>
    );
  })
)

const FormMultiselector = (key, labelText, items) => (
  ((props) => {
    const values = props.values[key];

    const checkItems = items.map((item, idx) =>
      <Checkbox
        key={key + item.value}
        name={`check-${key}`}
        value={item.value}
        checked={R.contains(item.value)(values)}
        onChange={() => {}}
      >
        {item.description}
      </Checkbox>
    );

    return (
      <FormRow>
        <FormLabel>{labelText}</FormLabel>
        <FormGroup
          onChange={props.multiselectHandler(key)}
          id={"multiselect-"+key}
        >
          {checkItems}
        </FormGroup>
      </FormRow>
    );
  })
)

const TextInput = (key, labelText) => (
  (props) => (
    <FormRow>
      <FormLabel>{labelText}</FormLabel>
      <FormField>
        <FormControl
          type="text"
          key={key}
          onChange={(e) => {e.persist(); props.textHandler(key)(e)}}
          value={props.values[key]}
          disabled={props.disabled}
        />
      </FormField>
    </FormRow>
  )
)

const NumberInput = (key, labelText) => (
  (props) => (
    <FormRow>
      <FormLabel>{labelText}</FormLabel>
      <FormField>
        <FormControl
          type="text"
          key={key}
          onChange={(e) => {e.persist(); props.textHandler(key)(stripNonNumbers(e))}}
          value={props.values[key]}
          disabled={props.disabled}
        />
      </FormField>
    </FormRow>
  )
)

const DateInput = (key, labelText) => (
  (props) => (
    <FormRow>
      <FormLabel>{labelText}</FormLabel>
      <FormField>
        <DatePicker id={key+'-datepicker'} value={props.values[key]} onChange={props.dateHandler(key)} disabled={props.disabled} />
      </FormField>
    </FormRow>
  )
)

const CompanyChoiceDueDatePicker = DateInput('companyChoiceDueDate', 'Due date for students to make company choice')
const PresentationDueDatePicker = DateInput('presentationDueDate', 'Due date for the presentation')
const PaperDueDatePicker = DateInput('paperDueDate', 'Due date for the paper submission')

const CheckInput = (key, labelText) => (
  (props) => (
    <FormRow>
      <FormLabel>{labelText}</FormLabel>
      <Checkbox
        name={`check-${key}`}
        disabled={props.disabled}
        checked={props.values[key]}
        onChange={props.checkHandler(key)} />
    </FormRow>
  )
)

const GroupSizePicker = FormSelector('groupSize',
    'Number of students per group',
    [ {'value': 1, 'description': '1'}
    , {'value': 2, 'description': '2'}
    , {'value': 3, 'description': '3'}
    , {'value': 4, 'description': '4'}
    ], undefined, (x)=>(1*x));

const SelectionTypePicker = CheckInput('studentsSelectOwnGroups', 'Check if students are to select their own groups');

const NumberOfCompaniesPicker = FormSelector('numCompanies',
    'Number of companies to compare',
    [ {value: 2, description: '2'}
    , {value: 3, description: '3'}
    ], undefined, (x)=>(1*x));


const LmsInput = FormSelector(LmsInputKey,
    'Which Learning Management System (LMS), if any, will you use?',
    [ {value: 'None', description: 'None'}
    , {value: 'Blackboard', description: 'Blackboard'}
    , {value: 'Moodle', description: 'Moodle'}
    , {value: 'Angel', description: 'Angel'}
    , {value: 'Bright Space', description: 'Bright Space'}
    , {value: 'Canvas', description: 'Canvas'}
    , {value: 'other', description: 'Other (please specify)'}
    ]);
const LmsOtherInput = TextInput('lmsOther', 'LMS name');

const NotificationMethodPicker = FormSelector('notificationMethod',
    'How should students notify you of their choice of company?',
    [ {value: 'email', description: 'By emailing you'}
    , {value: 'lms', description: 'On the LMS discussion board'}
    ]);

const ProfEmailInput = TextInput('email', 'What email address should students use to contact you?');
const ProfNameInput = TextInput('instructorName', 'Your name as you would like students to address you (i.e. Professor Smith)');

const PresentationMethodPicker = FormSelector(PresentationMethodKey,
    'How do you want students to make their project presentations?',
    [ {value: 'in-class', description: 'In-class presentations'}
    , {value: 'lms-video', description: 'Videos posted online in LMS'}
    , {value: 'none', description: 'I do not want to assign project presentations'}
    ]);

const PresentationLengthInput = NumberInput('presentationLength',
    'How long should the presentation be (in minutes)? Enter a single number, not a range, between 2 - 15 minutes.');

const SubmissionMethodPicker = FormSelector(SubmissionMethodKey,
    'How should students submit their final project paper?',
    [ {value: 'email', description: 'Email to instructor'}
    , {value: 'lms', description: 'Upload to LMS'}
    , {value: 'paper', description: 'Hand in paper copy'}
    , {value: 'none', description: 'I do not want to assign a written paper'}
    ]);

const PlagiarismPicker = CheckInput('plagiarismChecker',
    'Check if you will be using plagiarism software to check student submissions');

const InstructionsFor10K = CheckInput('instructions10k',
    'Check if you want to include instructions for how students should find the ' +
    'relevant Form 10-k for their selected companies');

const RubricForPresentation = CheckInput('includePresentationRubric',
    'Check if you want to include an oral presentation grading rubric in the case instructions');

const RubricForPaper = CheckInput('includePaperRubric',
    'Check if you want to include a written paper grading rubric in the case instructions');

const TopicPicker = FormMultiselector(TopicKey,
    'Select which of these topics you want to include in this case (select all that apply):',
    [ {value: 'overview', description: 'Overview of industry and companies'}
    , {value: 'cash', description: 'Cash'}
    , {value: 'shortTermInvestment', description: 'Short-term investments'}
    , {value: 'receivables', description: 'Receivables'}
    , {value: 'inventory', description: 'Inventory'}
    , {value: 'ppe', description: 'Property, plant, and equipment'}
    , {value: 'currentLiabilities', description: 'Current liabilities'}
    , {value: 'longTermLiabilities', description: 'Long-term liabilities'}
    , {value: 'stockholderEquity', description: 'Stockholders\' equity'}
    , {value: 'internalControls', description: 'Auditor\'s letter'}
    , {value: 'cashFlows', description: 'Statement of cash flows'}
    , {value: 'ratioAnalysis', description: 'Ratio analysis'}
    , {value: 'csr', description: 'Corporate social responsibility'}
    , {value: 'overallAnalysis', description: 'Overall analysis'}
    ]);


export default App;



// WEBPACK FOOTER //
// ./src/App.js